<template>
  <div v-if="mShowDialog">
    <div
      v-if="mShowDialogIndex === 1"
      class="tip-match-center-popup-wrap"
    >
      <div
        class="tip-match-popup-content"
      >
        <p class="tip-match-popup-title">
          {{ title }}
        </p>
        <p class="tip-match-popup-tip-desc">
          欢迎使用王者赛宝！我们依据相关规定制定了<span
            @click.stop="onClickGoProtocol"
          >《王者赛宝使用协议》</span>和<span
            @click.stop="onClickGoPrivacy"
          >《王者赛宝隐私协议》</span>帮助您了解我们所提供的服务以及我们收集和处理您个人信息的情况，并告知您所享有的相关权利。
          <br>
          为向您提供更加安全、便捷的服务，我们会在您使用相关功能时申请有关设备权限（例如您的相机、存储等）
        </p>

        <div class="tip-match-protocol">
          <div
            :class="['tip-match-check',
                     isChecked ? 'tip-match-checked' : '']"
            @click.stop="onToggleChecked"
          />
          <p>
            我已阅读并同意
            <span
              @click.stop="onClickGoProtocol()"
            >
              《王者赛宝使用协议》
            </span>和
            <span
              @click.stop="onClickGoPrivacy()"
            >
              《王者赛宝隐私协议》
            </span>
          </p>
        </div>
        <div class="tip-match-popup-btn-wrap">
          <div
            class="tip-match-secondary-samll-btn tip-match-btn-spacing"
            @click.stop="dialogOneCancel"
          >
            拒绝并退出
          </div>
          <div
            class="tip-match-primary-samll-btn"
            @click.stop="confirm"
          >
            <p>{{ mShowButtonLoading ? '' : "同意" }}</p>
            <ButtonLoading
              v-if="mShowButtonLoading"
              loading-scenes="btn"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="tip-match-center-popup-wrap"
    >
      <div
        class="tip-match-popup-content"
      >
        <p class="tip-match-popup-title" />
        <p class="tip-match-popup-tip-desc">
          如果您不同意<span
            @click.stop="onClickGoProtocol"
          >《王者赛宝使用协议》</span>和<span
            @click.stop="onClickGoPrivacy"
          >《王者赛宝隐私协议》</span> 我们将无法为您提供赛事服务
        </p>
        <div class="tip-match-popup-btn-wrap">
          <div
            class="tip-match-secondary-samll-btn tip-match-btn-spacing"
            @click.stop="cancel"
          >
            {{ subBtnText }}
          </div>
          <div
            class="tip-match-primary-samll-btn"
            style="position:relative"
            @click.stop="confirm"
          >
            <p>{{ mShowButtonLoading ? '' : "同意" }}</p>
            <ButtonLoading
              v-if="mShowButtonLoading"
              loading-scenes="btn"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonLoading from 'src/local-component/ui/tip-match/tip-match-loading-mode';
import { post } from '@tencent/pmd-network';
import { closeWebview } from 'src/local-logic/tip-match/homepage/close-webview';
import { gotoWebview } from 'src/local-logic/utils/webview';

const DISABLE_DIALOG_ROUTES = ['protocol', 'privacy'];

export default {
  components: {
    ButtonLoading,
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      mShowDialog: false,
      mShowDialogIndex: 1,
      mShowButtonLoading: false,
      isChecked: false,
    };
  },
  computed: {
    title() {
      return '王者赛宝使用协议与隐私政策';
      // return this.type === 1 ? '办赛授权' : '参赛授权';
    },
    subBtnText() {
      return '不同意并退出';
      // return this.type === 1 ? '放弃办赛' : '放弃参赛';
    },
  },
  mounted() {
    if (this.$route.path !== '/views/fake-home/index') {
      this.checkToShow();
    }

    // #ifdef H5
    // document.addEventListener('visibilitychange', function () {
    //   if (document.visibilityState == 'hidden') {
    //   } else {
    //     this.checkToShow();
    //   }
    // });
    // #endif
  },
  methods: {
    checkToShow() {
      const isAgreeTag = localStorage.getItem('user-agree-protocol-tag');
      if (isAgreeTag === '2') {
        this.isAlreadyAgree();
        this.onClickDismiss();
      } else if (isAgreeTag === '1') {
        this.realShowDialog();
      } else {
        // #ifndef MP-WEIXIN
        this.getProtocol();
        // #endif
        // #ifdef MP-WEIXIN
        this.realShowDialog();
        // #endif
      }
    },
    realShowDialog() {
      const routeName = this.$route.name;
      if (DISABLE_DIALOG_ROUTES.includes(routeName)) return;
      this.$store.commit('protocol/setShowDialog', true);
      this.mShowDialog = true;
    },
    isAlreadyAgree() {
      this.$store.commit('protocol/setShowDialog', false);
    },
    confirm() {
      if (!this.isChecked) {
        this.showToast('请勾选已阅读并同意选项');
        return;
      }
      this.agreeProtocol();
    },
    cancel() {
      this.$emit('onClickCancel');
      this.onClickDismiss();
    },
    // 取消,将promise断定为reject状态
    dialogOneCancel() {
      // this.mShowDialog = false;
      closeWebview();
      // this.mShowDialogIndex = 2;
    },
    touchRemove() {
      this.onClickDismiss();
    },
    onClickDismiss() {
      this.$emit('onClickDismiss');
    },
    agreeProtocol() {
      this.mShowButtonLoading = true;
      const reqData = {
        gid: 331,
      };
      post({
        url: '/pvpesport.sgamenes.nesholder.nesholder/ConfirmProtocol',
        reqData,
      }).then(() => {
        localStorage.setItem('user-agree-protocol-tag', '2');
        this.mShowButtonLoading = false;
        this.isAlreadyAgree();
        this.onClickDismiss();
      })
        .catch(() => {
          this.mShowButtonLoading = false;
        })
        .finally(() => {
          this.mShowDialog = false;
        });
    },
    onClickGoProtocol() {
      uni.navigateTo({ url: '/views/home/homepage/protocol' });
    },

    onClickGoPrivacy() {
      // uni.navigateTo({ url: '/views/home/homepage/privacy' });
      gotoWebview(this, '/views/home/homepage/privacy');
    },
    getProtocol() {
      const reqData = {
        gid: 331,
      };
      post({
        url: '/pvpesport.sgamenes.nesholder.nesholder/GetProtocolStatus',
        reqData,
      }).then(({ status }) => {
        console.log('getProtocol:', status);
        const isAgree = status === 2;
        if (isAgree) {
          localStorage.setItem('user-agree-protocol-tag', '2');
          this.isAlreadyAgree();
          this.onClickDismiss();
        } else {
          localStorage.setItem('user-agree-protocol-tag', '1');
          this.realShowDialog();
        }
      })
        .catch(() => {
          // 报错也当做同意处理
          this.onClickDismiss();
        });
    },
    onToggleChecked() {
      this.isChecked = !this.isChecked;
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss">
</style>
